import React from "react";
import { motion } from "framer-motion";
import { AlertTriangle } from "lucide-react";
import { PROBLEM_POINTS } from "../constants/content";

const ProblemSection = () => {
    return (
        <section data-testid="problem-section" className="relative overflow-hidden py-28 sm:py-36">
            <div className="bg-grid-fade absolute inset-0" />
            <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
                <motion.p
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.6 }}
                    className="font-mono-tech text-[11px] uppercase tracking-[0.35em] text-neon-pink"
                >
                    The Problem
                </motion.p>
                <motion.h2
                    initial={{ opacity: 0, y: 32 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, delay: 0.1 }}
                    className="font-display mt-5 max-w-3xl text-3xl font-extrabold leading-tight text-white sm:text-5xl"
                >
                    Struggling To <span className="text-gradient-neon">Monetize</span> Your Audience?
                </motion.h2>
                <motion.p
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, delay: 0.2 }}
                    className="mt-6 max-w-2xl text-base leading-relaxed text-white/75 sm:text-lg"
                >
                    Most Creators do, we get it... Make the algorithm your friend and stand out!
                    With the easiest way to convert engagement into passive income, and views to
                    sales in hours - not days!
                </motion.p>

                <div className="mt-14 grid gap-5 sm:grid-cols-3">
                    {PROBLEM_POINTS.map((p, i) => (
                        <motion.div
                            key={p.title}
                            initial={{ opacity: 0, y: 32 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.55, delay: i * 0.12 }}
                            data-testid={`problem-card-${i}`}
                            className="rounded-2xl border border-border bg-card/70 p-6 transition-colors duration-300 hover:border-neon-pink/40"
                        >
                            <AlertTriangle size={18} className="text-neon-pink" />
                            <h3 className="font-display mt-4 text-base font-bold text-white">{p.title}</h3>
                            <p className="mt-2 text-sm leading-relaxed text-white/70">{p.text}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ProblemSection;
